<template>
 <div id="g-page" >

  <table border="0" class="main-table-screen" >
    <tr>
      <td id="main-table-row1" colspan="1"> 
      </td>
    </tr>

    <tr>
      <td id="main-table-row2-dialog-container-td">

        <table class="dialog-table" border="0" align="center">
          <tr>
            <td id="dialog-td-title" class="radius-single-left-field-left-top radius-single-left-field-left-bottom radius-single-left-field-right-top radius-single-left-field-right-bottom" >
                <p> {{ $t("c19.title1") }}</p>
            </td>
            <td id="dialog-td-instructions" class="radius-single-right-field-left-top radius-single-right-field-left-bottom radius-single-right-field-right-top radius-single-right-field-right-bottom">
              {{ $t("c19.title2") }}
            </td>
          </tr>
        </table>

        <div style="height:10px;"></div>

        <!-- SECTION 1 -->
        <table class="dialog-table" align="center" >
          
          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3" >
              <!-- SECTION 1 TITLE -->
              {{ $t("c19.s1title") }}
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>
          <tr>
            <td colspan="2" class="dialog-question col4-width  border-dots-inner">
              <!-- QUESTION 1 -->
              <p class="wrap"> {{ $t("c19.s1Q1") }}</p>
            </td>
            <td class="dialog-input-field-right  border-dots" >
              
              <label for="currentlyHaveC19Yes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="currentlyHaveC19Yes" v-model="currentlyHaveC19Yes">
              &nbsp;
              <label for="currentlyHaveC19No">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="currentlyHaveC19No" v-model="currentlyHaveC19No">
            </td>
          </tr>
         
          <tr>
            <td colspan="2" class="dialog-question  border-dots-inner">
              <!-- QUESTION 2 -->
              <p class="wrap"> {{ $t("c19.s1Q2") }}</p>
            </td>
            <td class="dialog-input-field-right  border-dots" >
              <label for="previousTestedPositiveC19Yes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="previousTestedPositiveC19Yes" v-model="previousTestedPositiveC19Yes">
              &nbsp;
              <label for="previousTestedPositiveC19No">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="previousTestedPositiveC19No" v-model="previousTestedPositiveC19No">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space" >

            </td>
            <td class="dialog-sub-question  border-dots-inner">
              <!-- QUESTION 2 A -->
              {{ $t("c19.s1Q2a") }}
            </td>
            <td class="dialog-input-field-right  border-dots">
              <label for="previousTestedPositiveC19AYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" 
                     name="previousTestedPositiveC19AYes" 
                     v-model="input.previousTestedPositiveC19A"
                     :disabled="!input.previousTestedPositiveC19">
              &nbsp;
              <label for="previousTestedPositiveC19ANo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" 
                     name="previousTestedPositiveC19ANo" 
                     v-model="previousTestedPositiveC19ANo"
                     :disabled="!input.previousTestedPositiveC19">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 2 B -->
              {{ $t("c19.s1Q2b") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="previousTestedPositiveC19BYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" 
                      name="previousTestedPositiveC19BYes" 
                      v-model="input.previousTestedPositiveC19B"
                      :disabled="!input.previousTestedPositiveC19">
              &nbsp;
              <label for="previousTestedPositiveC19BNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" 
                     name="previousTestedPositiveC19BNo" 
                     v-model="previousTestedPositiveC19BNo"
                     :disabled="!input.previousTestedPositiveC19">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 2 C -->
              {{ $t("c19.s1Q2c") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="previousTestedPositiveC19CYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" 
                     name="previousTestedPositiveC19BYes" 
                     v-model="input.previousTestedPositiveC19C"
                     :disabled="!input.previousTestedPositiveC19">
              &nbsp;
              <label for="previousTestedPositiveC19CNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" 
                     name="previousTestedPositiveC19CNo" 
                     v-model="previousTestedPositiveC19CNo"
                     :disabled="!input.previousTestedPositiveC19">
            </td>
          </tr>

          <tr>
            <td colspan="2" class="dialog-question">
              <!-- QUESTION 3 -->
              <p class="wrap"> {{ $t("c19.s1Q3") }}</p>
            </td>
           <td class="dialog-input-field-right">
              <label for="contactWithC19DiagnosedPersonYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="contactWithC19DiagnosedPersonYes" v-model="contactWithC19DiagnosedPersonYes">
              &nbsp;
              <label for="contactWithC19DiagnosedPersonNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="contactWithC19DiagnosedPersonNo" v-model="contactWithC19DiagnosedPersonNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner" >
              <!-- IF YES THE EXPLAIN-->
              {{ $t("c19.ifyesexplain") }}
            </td>

            <td class="dialog-input-field-explain border-dots"> 
              <textarea name="contactWithC19DiagnosedPerson" 
                        cols=2
                        style="width:100%;resize: none;height:100%"
                        v-model="input.contactWithC19DiagnosedPersonExplain"
                        v-bind:placeholder="$t('c19.explain')" 
                        :disabled="!input.contactWithC19DiagnosedPerson"
                        :class="input.contactWithC19DiagnosedPerson ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr> 

          <tr>
            <td colspan="2" class="dialog-question">
              <!-- QUESTION 4 -->
              <p class="wrap"> {{ $t("c19.s1Q4") }}</p>
            </td>
            
            <td class="dialog-input-field-right">
              <label for="contactWithC19TravelerYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="contactWithC19TravelerYes" v-model="contactWithC19TravelerYes">
              &nbsp;
              <label for="contactWithC19TravelerNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="contactWithC19TravelerNo" v-model="contactWithC19TravelerNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question">
              <!-- QUESTION 4 COUNTRY -->
              {{ $t("c19.s1Q4country") }}
            </td>
            <td id="country" class="dialog-input-field-right"> 
              <select name="contactWithC19TravelerCountryId" 
                      v-model="input.contactWithC19TravelerCountryId"
                      :disabled="!input.contactWithC19Traveler"
                      :class="input.contactWithC19Traveler ? 'enabled' : 'disabled'">
                <option value="0">Select-one</option>
                <option value="1">Afghanistan</option>
                <option value="2">Ã…land Islands</option>
                <option value="3">Albania</option>
                <option value="4">Algeria</option>
                <option value="5">American Samoa</option>
                <option value="6">Andorra</option>
                <option value="7">Angola</option>
                <option value="8">Anguilla</option>
                <option value="9">Antarctica</option>
                <option value="10">Antigua and Barbuda</option>
                <option value="11">Argentina</option>
                <option value="12">Armenia</option>
                <option value="13">Aruba</option>
                <option value="14">Australia</option>
                <option value="15">Austria</option>
                <option value="16">Azerbaijan</option>
                <option value="17">Bahamas</option>
                <option value="18">Bahrain</option>
                <option value="19">Bangladesh</option>
                <option value="20">Barbados</option>
                <option value="21">Belarus</option>
                <option value="22">Belgium</option>
                <option value="23">Belize</option>
                <option value="24">Benin</option>
                <option value="25">Bermuda</option>
                <option value="26">Bhutan</option>
                <option value="27">Bolivia, Plurinational State of</option>
                <option value="28">Bonaire, Sint Eustatius and Saba</option>
                <option value="29">Bosnia and Herzegovina</option>
                <option value="30">Botswana</option>
                <option value="31">Bouvet Island</option>
                <option value="32">Brazil</option>
                <option value="33">British Indian Ocean Territory</option>
                <option value="34">Brunei Darussalam</option>
                <option value="35">Bulgaria</option>
                <option value="36">Burkina Faso</option>
                <option value="37">Burundi</option>
                <option value="38">Cambodia</option>
                <option value="39">Cameroon</option>
                <option value="40">Canada</option>
                <option value="41">Cape Verde</option>
                <option value="42">Cayman Islands</option>
                <option value="43">Central African Republic</option>
                <option value="44">Chad</option>
                <option value="45">Chile</option>
                <option value="46">China</option>
                <option value="47">Christmas Island</option>
                <option value="48">Cocos (Keeling) Islands</option>
                <option value="49">Colombia</option>
                <option value="50">Comoros</option>
                <option value="51">Congo</option>
                <option value="52">Congo, the Democratic Republic of the</option>
                <option value="53">Cook Islands</option>
                <option value="54">Costa Rica</option>
                <option value="55">CÃ´te d`Ivoire</option>
                <option value="56">Croatia</option>
                <option value="57">Cuba</option>
                <option value="58">CuraÃ§ao</option>
                <option value="59">Cyprus</option>
                <option value="60">Czech Republic</option>
                <option value="61">Denmark</option>
                <option value="62">Djibouti</option>
                <option value="63">Dominica</option>
                <option value="64">Dominican Republic</option>
                <option value="65">Ecuador</option>
                <option value="66">Egypt</option>
                <option value="67">El Salvador</option>
                <option value="68">Equatorial Guinea</option>
                <option value="69">Eritrea</option>
                <option value="70">Estonia</option>
                <option value="71">Ethiopia</option>
                <option value="72">Falkland Islands (Malvinas)</option>
                <option value="73">Faroe Islands</option>
                <option value="74">Fiji</option>
                <option value="75">Finland</option>
                <option value="76">France</option>
                <option value="77">French Guiana</option>
                <option value="78">French Polynesia</option>
                <option value="79">French Southern Territories</option>
                <option value="80">Gabon</option>
                <option value="81">Gambia</option>
                <option value="82">Georgia</option>
                <option value="83">Germany</option>
                <option value="84">Ghana</option>
                <option value="85">Gibraltar</option>
                <option value="86">Greece</option>
                <option value="87">Greenland</option>
                <option value="88">Grenada</option>
                <option value="89">Guadeloupe</option>
                <option value="90">Guam</option>
                <option value="91">Guatemala</option>
                <option value="92">Guernsey</option>
                <option value="93">Guinea</option>
                <option value="94">Guinea-Bissau</option>
                <option value="95">Guyana</option>
                <option value="96">Haiti</option>
                <option value="97">Heard Island and McDonald Islands</option>
                <option value="98">Holy See (Vatican City State)</option>
                <option value="99">Honduras</option>
                <option value="100">Hong Kong</option>
                <option value="101">Hungary</option>
                <option value="102">Iceland</option>
                <option value="103">India</option>
                <option value="104">Indonesia</option>
                <option value="105">Iran, Islamic Republic of</option>
                <option value="106">Iraq</option>
                <option value="107">Ireland</option>
                <option value="108">Isle of Man</option>
                <option value="109">Israel</option>
                <option value="110">Italy</option>
                <option value="111">Jamaica</option>
                <option value="112">Japan</option>
                <option value="113">Jersey</option>
                <option value="114">Jordan</option>
                <option value="115">Kazakhstan</option>
                <option value="116">Kenya</option>
                <option value="117">Kiribati</option>
                <option value="118">Korea, Democratic People`s Republic of</option>
                <option value="119">Korea, Republic of</option>
                <option value="120">Kuwait</option>
                <option value="121">Kyrgyzstan</option>
                <option value="122">Lao People`s Democratic Republic</option>
                <option value="123">Latvia</option>
                <option value="124">Lebanon</option>
                <option value="125">Lesotho</option>
                <option value="126">Liberia</option>
                <option value="127">Libya</option>
                <option value="128">Liechtenstein</option>
                <option value="129">Lithuania</option>
                <option value="130">Luxembourg</option>
                <option value="131">Macao</option>
                <option value="133">Madagascar</option>
                <option value="134">Malawi</option>
                <option value="135">Malaysia</option>
                <option value="136">Maldives</option>
                <option value="137">Mali</option>
                <option value="138">Malta</option>
                <option value="139">Marshall Islands</option>
                <option value="140">Martinique</option>
                <option value="141">Mauritania</option>
                <option value="142">Mauritius</option>
                <option value="143">Mayotte</option>
                <option value="144">Mexico</option>
                <option value="145">Micronesia, Federated States of</option>
                <option value="146">Moldova, Republic of</option>
                <option value="147">Monaco</option>
                <option value="148">Mongolia</option>
                <option value="149">Montenegro</option>
                <option value="150">Montserrat</option>
                <option value="151">Morocco</option>
                <option value="152">Mozambique</option>
                <option value="153">Myanmar</option>
                <option value="154">Namibia</option>
                <option value="155">Nauru</option>
                <option value="156">Nepal</option>
                <option value="157">Netherlands</option>
                <option value="158">New Caledonia</option>
                <option value="159">New Zealand</option>
                <option value="160">Nicaragua</option>
                <option value="161">Niger</option>
                <option value="162">Nigeria</option>
                <option value="163">Niue</option>
                <option value="164">Norfolk Island</option>
                <option value="165">Northern Mariana Islands</option>
                <option value="166">Norway</option>
                <option value="167">Oman</option>
                <option value="168">Pakistan</option>
                <option value="169">Palau</option>
                <option value="170">Palestine, State of</option>
                <option value="171">Panama</option>
                <option value="172">Papua New Guinea</option>
                <option value="173">Paraguay</option>
                <option value="174">Peru</option>
                <option value="175">Philippines</option>
                <option value="176">Pitcairn</option>
                <option value="177">Poland</option>
                <option value="178">Portugal</option>
                <option value="179">Puerto Rico</option>
                <option value="180">Qatar</option>
                <option value="181">RÃ©union</option>
                <option value="182">Romania</option>
                <option value="183">Russian Federation</option>
                <option value="184">Rwanda</option>
                <option value="185">Saint BarthÃ©lemy</option>
                <option value="187">Saint Kitts and Nevis</option>
                <option value="188">Saint Lucia</option>
                <option value="189">Saint Martin (French part)</option>
                <option value="190">Saint Pierre and Miquelon</option>
                <option value="191">Saint Vincent and the Grenadines</option>
                <option value="192">Samoa</option>
                <option value="193">San Marino</option>
                <option value="194">Sao Tome and Principe</option>
                <option value="195">Saudi Arabia</option>
                <option value="196">Senegal</option>
                <option value="197">Serbia</option>
                <option value="198">Seychelles</option>
                <option value="199">Sierra Leone</option>
                <option value="200">Singapore</option>
                <option value="201">Sint Maarten (Dutch part)</option>
                <option value="202">Slovakia</option>
                <option value="203">Slovenia</option>
                <option value="204">Solomon Islands</option>
                <option value="205">Somalia</option>
                <option value="206">South Africa</option>
                <option value="208">South Sudan</option>
                <option value="209">Spain</option>
                <option value="210">Sri Lanka</option>
                <option value="211">Sudan</option>
                <option value="212">Suriname</option>
                <option value="213">Svalbard and Jan Mayen</option>
                <option value="214">Swaziland</option>
                <option value="215">Sweden</option>
                <option value="216">Switzerland</option>
                <option value="217">Syrian Arab Republic</option>
                <option value="218">Taiwan, Province of China</option>
                <option value="219">Tajikistan</option>
                <option value="220">Tanzania, United Republic of</option>
                <option value="221">Thailand</option>
                <option value="222">Timor-Leste</option>
                <option value="223">Togo</option>
                <option value="224">Tokelau</option>
                <option value="225">Tonga</option>
                <option value="226">Trinidad and Tobago</option>
                <option value="227">Tunisia</option>
                <option value="228">Turkey</option>
                <option value="229">Turkmenistan</option>
                <option value="230">Turks and Caicos Islands</option>
                <option value="231">Tuvalu</option>
                <option value="232">Uganda</option>
                <option value="233">Ukraine</option>
                <option value="234">United Arab Emirates</option>
                <option value="235">United Kingdom</option>
                <option value="236">United States</option>
                <option value="237">United States Minor Outlying Islands</option>
                <option value="238">Uruguay</option>
                <option value="239">Uzbekistan</option>
                <option value="240">Vanuatu</option>
                <option value="241">Venezuela, Bolivarian Republic of</option>
                <option value="242">Viet Nam</option>
                <option value="243">Virgin Islands, British</option>
                <option value="244">Virgin Islands, U.S.</option>
                <option value="245">Wallis and Futuna</option>
                <option value="246">Western Sahara</option>
                <option value="247">Yemen</option>
                <option value="248">Zambia</option>
                <option value="249">Zimbabwe</option>
              </select>
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              {{ $t("c19.explain") }}
            </td>

            <td class="dialog-input-field-explain border-dots"> 
              <textarea name="contactWithC19Traveler" 
                        cols=2
                        style="width:100%;resize: none;height:100%"
                        v-model="input.contactWithC19TravelerExplain"
                        v-bind:placeholder="$t('c19.explain')" 
                        :disabled="!input.contactWithC19Traveler"
                        :class="input.contactWithC19Traveler ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr> 

          <tr>
            
            <td colspan="2" class="dialog-question">
              <!-- QUESTION 5 -->
              <p class="wrap"> {{ $t("c19.s1Q5") }}</p>
            </td>
            
            <td class="dialog-input-field-right">
              <label for="chronicConditionsYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="chronicConditionsYes" v-model="chronicConditionsYes">
              &nbsp;
              <label for="chronicConditionsNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="chronicConditionsNo" v-model="chronicConditionsNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- IF YES THE LIST -->
              {{ $t("c19.ifyeslist") }}
            </td>

            <td class="dialog-input-field-explain border-dots"> 
              <textarea name="chronicConditions" 
                        cols=2
                        style="width:100%;resize: none;height:100%"
                        v-model="input.chronicConditionsExplain"
                        v-bind:placeholder="$t('c19.explain')" 
                        :disabled="!input.chronicConditions"
                        :class="input.chronicConditions ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr> 

          <tr>
            <td colspan="2" class="dialog-question">
              <!-- QUESTION 6 -->
              <p class="wrap"> {{ $t("c19.s1Q6") }}</p>
            </td>
            
            <td class="dialog-input-field-right">
              <label for="compromisedImmunityYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="compromisedImmunityYes" v-model="compromisedImmunityYes">
              &nbsp;
              <label for="compromisedImmunityNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="compromisedImmunityNo" v-model="compromisedImmunityNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question">
              <!-- IF YES THEN LIST -->
              {{ $t("c19.ifyeslist") }}
            </td>

            <td class="dialog-input-field-explain" > 
              <textarea name="compromisedImmunity" 
                        cols=2
                        style="width:100%;resize: none;height:100%"
                        v-model="input.compromisedImmunityExplain"
                        v-bind:placeholder="$t('c19.explain')" 
                        :disabled="!input.compromisedImmunity" 
                        :class="input.compromisedImmunity ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr>
           <tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="dialog-input-field-explain radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>
  
          <div style="height:10px;"></div>

          <!--SECTION 2 -->
          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
                <!-- SECTION 2 TITLE -->
                <p> {{ $t("c19.s2title") }}</p>
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>

          <tr border="1">
            <td class="dialog-question border-dots-inner" colspan="2" >
              <!-- TEMPERATURE -->
              <p class="wrap">  {{ $t("c19.s2Temperature") }}</p>
            </td>

            <td class="dialog-input-field-right border-dots" style="padding-top:3px;padding-bottom:3px"> 
              <input type="number" 
                    name="temperature" 
                    v-model="input.temperature" 
                    style="width:100px;" 
                    placeholder="XXX.XX" 
                    maxlength="6"
                    min="0"
                    max="999.99"
                    onKeyPress="if(this.value.length==6) return false;"
                    >
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">

            </td>

            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 1 -->
              {{ $t("c19.s2Q1") }}
            </td>
            
            <td class="dialog-input-field-right border-dots">
              <label for="temperaturePastNDaysYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="temperaturePastNDaysYes" v-model="temperaturePastNDaysYes">
              &nbsp;
              <label for="temperaturePastNDaysNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="temperaturePastNDaysNo" v-model="temperaturePastNDaysNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space ">

            </td>

            <td class="dialog-sub-question">
              <!-- QUESTION 2 -->
              {{ $t("c19.s2Q2") }}
            </td>

            <td class="dialog-input-field-right ">
              <label for="usedDigitalThermometerYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="usedDigitalThermometerYes" v-model="usedDigitalThermometerYes">
              &nbsp;
              <label for="usedDigitalThermometerNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="usedDigitalThermometerNo" v-model="usedDigitalThermometerNo">
            </td>

          </tr>
          <tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="dialog-input-field-explain radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>
  

          <!-- SECTION 3-->
          <div style="height:10px;"></div>

          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <!-- SECTION 3 TITLE -->
              <p> {{ $t("c19.s3title") }}</p>
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>

          <tr>
            <td class="dialog-question" colspan="3">
              <!-- INSTRUCTIONS -->
              <p class="wrap"> {{ $t("c19.s3Instructions") }}</p>
              <br>
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 1 -->
              {{ $t("c19.s3Q1") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="wetCoughProductiveYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="wetCoughProductiveYes" v-model="wetCoughProductiveYes">
              &nbsp;
              <label for="wetCoughProductiveNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="wetCoughProductiveNo" v-model="wetCoughProductiveNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 2 -->
              {{ $t("c19.s3Q2") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="wetCoughNonProductiveYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="wetCoughNonProductiveYes" v-model="wetCoughNonProductiveYes">
              &nbsp;
              <label for="wetCoughNonProductiveNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="wetCoughNonProductiveNo" v-model="wetCoughNonProductiveNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 3 -->
              {{ $t("c19.s3Q3") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="dryCoughYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="dryCoughYes" v-model="dryCoughYes">
              &nbsp;
              <label for="dryCoughNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="dryCoughNo" v-model="dryCoughNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 4 -->
              {{ $t("c19.s3Q4") }}
            </td>
          <td class="dialog-input-field-right border-dots">
              <label for="soreThroatYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="soreThroatYes" v-model="soreThroatYes">
              &nbsp;
              <label for="soreThroatNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="soreThroatNo" v-model="soreThroatNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 5 -->
              {{ $t("c19.s3Q5") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="congestionRunningNoseYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="congestionRunningNoseYes" v-model="congestionRunningNoseYes">
              &nbsp;
              <label for="congestionRunningNoseNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="congestionRunningNoseNo" v-model="congestionRunningNoseNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 6 -->
              {{ $t("c19.s3Q6") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="shortnessOfBreathYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="shortnessOfBreathYes" v-model="shortnessOfBreathYes">
              &nbsp;
              <label for="shortnessOfBreathNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="shortnessOfBreathNo" v-model="shortnessOfBreathNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 7 -->
              {{ $t("c19.s3Q7") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="chillsYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="chillsYes" v-model="chillsYes">
              &nbsp;
              <label for="chillsNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="chillshNo" v-model="chillsNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 8 -->
              {{ $t("c19.s3Q8") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="headacheYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="headacheYes" v-model="headacheYes">
              &nbsp;
              <label for="headacheNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="headacheNo" v-model="headacheNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 9 -->
              {{ $t("c19.s3Q9") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="lossOfSmellYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="lossOfSmellYes" v-model="lossOfSmellYes">
              &nbsp;
              <label for="lossOfSmellNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="lossOfSmellNo" v-model="lossOfSmellNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 10 -->
              {{ $t("c19.s3Q10") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="lossOfTasteYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="lossOfTasteYes" v-model="lossOfTasteYes">
              &nbsp;
              <label for="lossOfTasteNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="lossOfTasteNo" v-model="lossOfTasteNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 11 -->
              {{ $t("c19.s3Q11") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="lossOfAppetiteYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="lossOfAppetiteYes" v-model="lossOfAppetiteYes">
              &nbsp;
              <label for="lossOfTasteNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="lossOfAppetiteNo" v-model="lossOfAppetiteNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 12 -->
              {{ $t("c19.s3Q12") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="pinkEyeYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="pinkEyeYes" v-model="pinkEyeYes">
              &nbsp;
              <label for="pinkEyeNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="pinkEyeNo" v-model="pinkEyeNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 13 -->
              {{ $t("c19.s3Q13") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="bodyAchesMuscleJointPainYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="bodyAchesMuscleJointPainYes" v-model="bodyAchesMuscleJointPainYes">
              &nbsp;
              <label for="bodyAchesMuscleJointPainNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="bodyAchesMuscleJointPainNo" v-model="bodyAchesMuscleJointPainNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 14 -->
              {{ $t("c19.s3Q14") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="suddenConfusionYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="suddenConfusionYes" v-model="suddenConfusionYes">
              &nbsp;
              <label for="suddenConfusionNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="suddenConfusionNo" v-model="suddenConfusionNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 15 -->
              {{ $t("c19.s3Q15") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="digestiveSystemYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="digestiveSystemYes" v-model="digestiveSystemYes">
              &nbsp;
              <label for="digestiveSystemNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="digestiveSystemNo" v-model="digestiveSystemNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 16 -->
              {{ $t("c19.s3Q16") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="fatigueYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="fatigueYes" v-model="fatigueYes">
              &nbsp;
              <label for="fatigueNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="fatigueNo" v-model="fatigueNo">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!-- QUESTION 17 -->
              {{ $t("c19.s3Q17") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="chestPainYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="chestPainYes" v-model="chestPainYes">
              &nbsp;
              <label for="chestPainNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="chestPainNo" v-model="chestPainNo">
            </td>
          </tr>
          
          <tr>
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question" >
              <!-- SYMPTOMS -->
              {{ $t("c19.s3symptoms") }}
            </td>
            <td class="dialog-question" style="text-align:right;padding-right:10px" colspan="2">
              <!-- DATE -->
              {{ $t("c19.s3date") }}
            <input type="date" v-model="input.symptomStartDate">
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="dialog-input-field-explain radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>

          <!-- VACCINATIONS -->
          <div style="height:10px;"></div>
          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <!-- VACCINE TITLE -->
              <p> {{ $t("c19.s4Title") }}</p>
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>
          <tr>
            <td colspan="2" class="dialog-question border-dots-inner">
             <p class="wrap"> {{ $t("c19.s4Q1") }}</p>
            </td>
            
            <td class="dialog-input-field-right border-dots">
              <label for="vaccinationYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="vaccinationYes" v-model="vaccinationYes">
              &nbsp;
              <label for="vaccinationNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="vaccinationNo" v-model="vaccinationNo">
            </td>
          </tr>

          <tr v-if="input.vaccination == true">
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">             
              {{ $t("c19.s4Q1vaccine") }}
            </td>
            <td id="vaccineId" class="dialog-input-field-right border-dots"> 
              <select name="vaccineId" 
                      v-model="input.vaccineId"
                      :disabled="!input.vaccination"
                      :class="input.vaccination ? 'enabled' : 'disabled'">
                <option value="0">Select-one</option>
                <option value="1">Pfizer</option>
                <option value="2">Moderna</option>
                <option value="3">Johnson &amp; Johnson</option>               
              </select>
            </td>
          </tr>
          <tr v-if="input.vaccination == true && input.vaccineId == 3">
            <td class="dialog-question-space border-dots-inner">
            </td>
            <td class="dialog-sub-question border-dots-inner">
                {{ $t("c19.s4Q1VaccineDose1") }}
            </td>
            <td class="dialog-input-field-explain border-dots"> 
              <input type="date" v-model="vaccineDose1">
            </td>
          </tr>
          <!-- booster -->
          <tr v-if="input.vaccination == true && input.vaccineId == 3">
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question border-dots-inner">
                {{ $t("c19.s4Q1VaccineDose3") }}
            </td>
            <td class="dialog-input-field-explain border-dots"> 
              <input type="date" v-model="vaccineDose3">
            </td>
          </tr>
          <tr v-if="input.vaccination == true && (input.vaccineId == 1 || input.vaccineId == 2)">
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question">
                {{ $t("c19.s4Q1VaccineDose1") }}
            </td>
            <td class="dialog-input-field-explain"> 
              <input type="date" v-model="vaccineDose1">
            </td>
          </tr>
          <tr v-if="input.vaccination == true && (input.vaccineId == 1 || input.vaccineId == 2)">
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question">
                {{ $t("c19.s4Q1VaccineDose2") }}
            </td>
            <td class="dialog-input-field-explain"> 
              <input type="date" v-model="vaccineDose2">
            </td>
          </tr> 
          <!-- booster -->
          <tr v-if="input.vaccination == true && (input.vaccineId == 1 || input.vaccineId == 2)">
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question">
                {{ $t("c19.s4Q1VaccineDose3") }}
            </td>
            <td class="dialog-input-field-explain"> 
              <input type="date" v-model="vaccineDose3">
            </td>
          </tr>

          <tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="dialog-input-field-explain radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>


          <!-- MENTAL HEALTH -->
          <div style="height:10px;"></div>
          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <p> {{ $t("c19.s5Title") }}</p>
              <!--"MEDICAL WELLNESS"-->
            </td>
          </tr>
          <tr>
            <td colspan="2" class="dialog-question border-dots-inner">
             <p class="wrap"> {{ $t("c19.sQMH1FeelingToday") }}</p>
             <!--"How are you feeling today? (Early intervention will give you the best chance to minimize disability.)"-->
            </td>
            
            <td class="dialog-input-field-right border-dots">
              <label for="feelingTodayFine">{{ $t("c19.sQMH1FeelingTodayTotallyFine")  }}<!--"Totally Fine"--></label>&nbsp;
              <input type="checkbox" name="feelingTodayFine" v-model="feelingTodayFine">
              &nbsp;
              <label for="feelingTodayNotGreat">{{ $t("c19.sQMH1FeelingTodayNotGreat") }}<!--"Not Great"--></label>&nbsp;
              <input type="checkbox" name="feelingTodayNotGreat" v-model="feelingTodayNotGreat">
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true">
            <td class="dialog-question-space ">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("c19.sMH1FeelingTodayWeeks") }}
              <!-- "1.	Have you experienced any Anxiety and or Depression over the past 2 weeks ?"-->
            </td>
            <td class="dialog-input-field-right border-dots" colspan="2">
              <label for="MH1FeelingTodayWeeksYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH1FeelingTodayWeeksYes" v-model="MH1FeelingTodayWeeksYes">
              &nbsp;
              <label for="MH1FeelingTodayWeeksNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH1FeelingTodayWeeksNo" v-model="MH1FeelingTodayWeeksNo">
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true && input.MH1FeelingTodayWeeks == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("c19.sMH1FeelingTodayWeeksNervousAnxious") }}
                    <!--"a. Feeling nervous, anxious or on edge."-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="MH1FeelingTodayWeeksNervousAnxious" class="dialog-input-field-right border-dots"> 
              <select name="MH1FeelingTodayWeeksNervousAnxious" 
                      v-model="input.MH1FeelingTodayWeeksNervousAnxious">
                <option value=0>{{ $t("c19.selectOne") }}</option>
                <option value=1>{{ $t("c19.notAtAll") }}</option>
                <option value=2>{{ $t("c19.serveralDays") }}</option>
                <option value=3>{{ $t("c19.moreThanHalfTheDays") }}</option>               
                <option value=4>{{ $t("c19.nearlyEveryday") }}</option>
              </select>
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true && input.MH1FeelingTodayWeeks == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner"> 
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">                   
                    {{ $t("c19.sMH1FeelingTodayWeeksWorrying") }}
                    <!--"b. Not being able to stop or control worrying."-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="MH1FeelingTodayWeeksWorrying" class="dialog-input-field-right border-dots"> 
              <select name="MH1FeelingTodayWeeksWorrying" 
                      v-model="input.MH1FeelingTodayWeeksWorrying">
                <option value=0>{{ $t("c19.selectOne") }}</option>
                <option value=1>{{ $t("c19.notAtAll") }}</option>
                <option value=2>{{ $t("c19.serveralDays") }}</option>
                <option value=3>{{ $t("c19.moreThanHalfTheDays") }}</option>               
                <option value=4>{{ $t("c19.nearlyEveryday") }}</option>
              </select>
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true && input.MH1FeelingTodayWeeks == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">  
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">  
                    {{ $t("c19.sMH1FeelingTodayWeeksDepression") }}
                    <!--"c. Feeling down, depressed, or hopeless."-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="MH1FeelingTodayWeeksDepression" class="dialog-input-field-right border-dots"> 
              <select name="MH1FeelingTodayWeeksDepression" 
                      v-model="input.MH1FeelingTodayWeeksDepression">
                <option value=0>{{ $t("c19.selectOne") }}</option>
                <option value=1>{{ $t("c19.notAtAll") }}</option>
                <option value=2>{{ $t("c19.serveralDays") }}</option>
                <option value=3>{{ $t("c19.moreThanHalfTheDays") }}</option>               
                <option value=4>{{ $t("c19.nearlyEveryday") }}</option>
              </select>
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true && input.MH1FeelingTodayWeeks == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">   
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">  
                    {{ $t("c19.sMH1FeelingTodaySuicidalHomicidal") }}
                    <!--"d. Feeling Suicidal or Homicidal."-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="MH1FeelingTodaySuicidalHomicidal" class="dialog-input-field-right border-dots"> 
              <select name="MH1FeelingTodaySuicidalHomicidal" 
                      v-model="input.MH1FeelingTodaySuicidalHomicidal">
                <option value=0>{{ $t("c19.selectOne") }}</option>
                <option value=1>{{ $t("c19.notAtAll") }}</option>
                <option value=2>{{ $t("c19.serveralDays") }}</option>
                <option value=3>{{ $t("c19.moreThanHalfTheDays") }}</option>               
                <option value=4>{{ $t("c19.nearlyEveryday") }}</option>
              </select>
              <br>
              <div style="height:10px" />
            </td>
          </tr>

          <tr v-if="input.MH1FeelingToday == true">
            <td class="dialog-question-space ">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("c19.sMH2WakeRestful") }}
              <!-- "2.	Did you wake up restful today?"-->
            </td>
            <td class="dialog-input-field-right border-dots" colspan="2">
              <label for="MH2WakeRestfulYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH2WakeRestfulYes" v-model="MH2WakeRestfulYes">
              &nbsp;
              <label for="MH2WakeRestfulNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH2WakeRestfulNo" v-model="MH2WakeRestfulNo">
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true && input.MH2WakeRestful == false">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">  
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">  
                    {{ $t("c19.sMH2WakeRestfulHoursOfSleep") }}
                    <!--"a. How many hours did you sleep?"-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="MH2WakeRestfulHoursOfSleep" class="dialog-input-field-right border-dots"> 
              <select name="MH2WakeRestfulHoursOfSleep" 
                      v-model="input.MH2WakeRestfulHoursOfSleep">
                <option value=0>Select-one</option>
                <option value=1>1</option>
                <option value=2>2</option>
                <option value=3>3</option>               
                <option value=4>4</option>
                <option value=5>5</option>
                <option value=6>6</option>
                <option value=7>7</option>
                <option value=8>8+</option>
              </select>
            </td>
          </tr>

          <tr v-if="input.MH1FeelingToday == true && input.MH2WakeRestful == false">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">  
                    {{ $t("c19.sMH2WakeRestfulSleepTimeliness") }}
                    <!-- "b.	Do you go to sleep within an hour of the same time each night?"-->
                  </td>
                </tr>
              </table>
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="MH2WakeRestfulSleepTimelinessYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH2WakeRestfulSleepTimelinessYes" v-model="MH2WakeRestfulSleepTimelinessYes">
              &nbsp;
              <label for="MH2WakeRestfulSleepTimelinessNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH2WakeRestfulSleepTimelinessNo" v-model="MH2WakeRestfulSleepTimelinessNo">
              <br>
              <div style="height:10px" />
            </td>
          </tr>

          <tr v-if="input.MH1FeelingToday == true">
            <td class="dialog-question-space ">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("c19.sMH3FollowingDoctorOrders") }}
              <!--"3. Have you been following any/all of your doctor’s health recommendations?"-->
            </td>
            <td class="dialog-input-field-right border-dots" colspan="2">
              <label for="MH3FollowingDoctorOrdersYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH3FollowingDoctorOrdersYes" v-model="MH3FollowingDoctorOrdersYes">
              &nbsp;
              <label for="MH3FollowingDoctorOrdersNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH3FollowingDoctorOrdersNo" v-model="MH3FollowingDoctorOrdersNo">
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true">
            <td class="dialog-question-space ">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("c19.sMH4TakingPrescribedMeds") }}
              <!--"4.	Have you been taking any/all of your doctor prescribed medications?"-->
            </td>
            <td class="dialog-input-field-right border-dots" colspan="2">
              <label for="MH4TakingPrescribedMedsYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH4TakingPrescribedMedsYes" v-model="MH4TakingPrescribedMedsYes">
              &nbsp;
              <label for="MH4TakingPrescribedMedsNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH4TakingPrescribedMedsNo" v-model="MH4TakingPrescribedMedsNo">
            </td>
          </tr>

          <tr v-if="input.MH1FeelingToday == true">
            <td class="dialog-question-space ">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("c19.sMH5Accommodations") }}
              <!--"5.	Do you need any Accommodations today?"-->
            </td>
            <td class="dialog-input-field-right border-dots" colspan="2">
              <label for="MH5AccommodationsYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsYes" v-model="MH5AccommodationsYes">
              &nbsp;
              <label for="MH5AccommodationsNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsNo" v-model="MH5AccommodationsNo">
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true && input.MH5Accommodations == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">   
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">              
                    {{ $t("c19.sMH5AccommodationsJobApplicationAdjustment") }}
                    <!--"a. Request an adjustments to the job application process so a qualified applicant with a disability can be considered for a position."-->
                  </td>
                </tr>
              </table>  
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="MH5AccommodationsJobApplicationAdjustmentYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsJobApplicationAdjustmentYes" v-model="MH5AccommodationsJobApplicationAdjustmentYes">
              &nbsp;
              <label for="MH5AccommodationsJobApplicationAdjustmentNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsJobApplicationAdjustmentNo" v-model="MH5AccommodationsJobApplicationAdjustmentNo">
            </td>
          </tr>

          <tr v-if="input.MH1FeelingToday == true && input.MH5Accommodations == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">    
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">              
                    {{ $t("c19.sMH5AccommodationsWorkScheduleModification") }}
                    <!--"b.  Request a modification to the physical work environment, or to the way a job is usually performed, so an individual with a disability can perform the essential functions of that position."-->
                  </td>
                </tr>
              </table> 
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="MH5AccommodationsWorkScheduleModificationYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsWorkScheduleModificationYes" v-model="MH5AccommodationsWorkScheduleModificationYes">
              &nbsp;
              <label for="MH5AccommodationsWorkScheduleModificationNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsWorkScheduleModificationNo" v-model="MH5AccommodationsWorkScheduleModificationNo">
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true && input.MH5Accommodations == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">
               <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">             
                    {{ $t("c19.sMH5AccommodationsEqualBenefitsChange") }}
                    <!-- "c. Request changes that enable an employee with a disability to enjoy equal benefits and privileges of employment like those that are enjoyed by other employees without disabilities. This may include access to cafeterias, lounges, auditoriums, and company-provided transportation."-->
                  </td>
                </tr>
              </table>   
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="MH5AccommodationsEqualBenefitsChangeYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsEqualBenefitsChangeYes" v-model="MH5AccommodationsEqualBenefitsChangeYes">
              &nbsp;
              <label for="MH5AccommodationsEqualBenefitsChangeNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsEqualBenefitsChangeNo" v-model="MH5AccommodationsEqualBenefitsChangeNo">
            </td>
          </tr>
          <tr v-if="input.MH1FeelingToday == true && input.MH5Accommodations == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">  
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">
                    {{ $t("c19.sMH5AccommodationsDoctorsAppointment") }}
                    <!--"d. Request a doctors appointment."-->
                  </td>
                </tr>
              </table>    
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="MH5AccommodationsDoctorsAppointmentYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsDoctorsAppointmentYes" v-model="MH5AccommodationsDoctorsAppointmentYes">
              &nbsp;
              <label for="MH5AccommodationsDoctorsAppointmentNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH5AccommodationsDoctorsAppointmentNo" v-model="MH5AccommodationsDoctorsAppointmentNo">
            </td>
          </tr>

          <tr v-if="input.MH1FeelingToday == true">
            <td class="dialog-question-space ">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("c19.sMH6Other") }}
              <!--"6.	Is something else bothering you today?"-->
            </td>
           
            <td class="dialog-input-field-right border-dots">
              <label for="MH6OtherYes">{{ $t("c19.yes") }}</label>&nbsp;
              <input type="checkbox" name="MH6OtherYes" v-model="MH6OtherYes">
              &nbsp;
              <label for="MH6OtherNo">{{ $t("c19.no") }}</label>&nbsp;
              <input type="checkbox" name="MH6OtherNo" v-model="MH6OtherNo">
            </td>
          </tr>

          <tr v-if="input.MH1FeelingToday == true && input.MH6Other == true">
            <td class="dialog-question-space border-dots-inner">

            </td>
            <td class="dialog-sub-question border-dots-inner">
               <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">  
                    <!-- IF YES THE EXPLAIN-->           
                    {{ $t("c19.ifyesexplain") }}
                  </td>
                </tr>
              </table>   
            </td>
            <td class="dialog-input-field-explain border-dots"> 
              <textarea name="contactWithC19DiagnosedPerson" 
                        cols=2
                        style="width:100%;resize: none;height:100%"
                        v-model="input.MH6OtherExplain"
                        v-bind:placeholder="$t('c19.explain')" 
                        :disabled="!input.MH6Other"
                        :class="input.MH6Other ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr> 

          <tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="dialog-input-field-explain radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>


          <!-- AGREEMENT-->
          <div style="height:10px;"></div>

          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <!-- TERMS TITLE -->
              <p> {{ $t("c19.termsTitle") }}</p>
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space ">
            </td>
            <td class="dialog-sub-question" >
              <!-- TERMS STATEMENT -->
              {{ $t("c19.termsStatement") }}
            </td>
            <td class="dialog-input-field-right" >
              <!-- AGREE -->
              <label for="agreementYes">{{ $t("c19.termsAgree") }}</label>&nbsp;
              <input type="checkbox" name="agreementYes" v-model="agreementYes">
              &nbsp;
              <!-- DISAGREE -->
              <label for="agreementNo">{{ $t("c19.termsDisagree") }}</label>&nbsp;
              <input type="checkbox" name="agreementNo" v-model="agreementNo">
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="dialog-input-field-explain radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>
          
          <div style="height:10px;"></div>

          <tr>
            <td class="dialog-input-submit" colspan="3" align="center" style="border-top-left-radius:15px;border-top-right-radius:15px;  border-bottom-left-radius:15px;border-bottom-right-radius:15px;">
                <input type="button" v-on:click="submit()" :disabled="input.isLoading" v-bind:value="$t('c19.submit')" >
            </td>
          </tr>
      
        </table>
      </td>
    </tr>
    
    <tr>
      <td id="main-table-row3" colspan="1" > 
      </td>
    </tr>
  </table>

  </div>
</template>

<script>
    //import { API } from '../../../api/member-api'
    const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

    //import { SUPPORT } from '../../../api/member-api'
    const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

    import messageBox from '.././common/message-box'
    import confirmBox from './c19-confirm-box'
    import moment from 'moment'

    export default {
      name: 'c19-daily-questionniare',
      mounted(){
        
        // SHOW TOP OF VIEW
        window.scrollTo(0, 0);

        this.load();
      },
      computed:
      {
        currentlyHaveC19Yes:
        {
          get: function() {return this.input.currentlyHaveC19;},
          set: function(val) { this.input.currentlyHaveC19 = val;}
          
        },
        currentlyHaveC19No:
        { 
          get: function() {return ( this.input.currentlyHaveC19 == true ) ? false : true;},
          set: function(val){ this.input.currentlyHaveC19 = (val == true ) ? false: true;}
        },
        previousTestedPositiveC19Yes:
        {
          get: function() {return this.input.previousTestedPositiveC19},
          set: function(val) { this.input.previousTestedPositiveC19 = val;}
        },
        previousTestedPositiveC19No:
        { 
          get: function() {return ( this.input.previousTestedPositiveC19 == true ) ? false : true;},
          set: function(val)
                { 
                  this.input.previousTestedPositiveC19 = (val == true ) ? false: true;
                  this.input.previousTestedPositiveC19A = false;
                  this.input.previousTestedPositiveC19B = false;
                  this.input.previousTestedPositiveC19C = false;
                }
        },   
        previousTestedPositiveC19AYes:
        {
          get: function() {return this.input.previousTestedPositiveC19A},
          set: function(val) { this.input.previousTestedPositiveC19A = val;}
        },
        previousTestedPositiveC19ANo:
        { 
          get: function() {return ( this.input.previousTestedPositiveC19A == true ) ? false : true;},
          set: function(val){ this.input.previousTestedPositiveC19A = (val == true ) ? false: true;}
        },  
        previousTestedPositiveC19BYes:
        {
          get: function() {return this.input.previousTestedPositiveC19B},
          set: function(val) { this.input.previousTestedPositiveC19B = val;}
        },  
        previousTestedPositiveC19BNo:
        { 
          get: function() {return ( this.input.previousTestedPositiveC19B == true ) ? false : true;},
          set: function(val){ this.input.previousTestedPositiveC19B = (val == true ) ? false: true;}
        },    
        previousTestedPositiveC19CYes:
        {
          get: function() {return this.input.previousTestedPositiveC19C},
          set: function(val) { this.input.previousTestedPositiveC19C = val;}
        },  
        previousTestedPositiveC19CNo:
        { 
          get: function() {return ( this.input.previousTestedPositiveC19C == true ) ? false : true;},
          set: function(val){ this.input.previousTestedPositiveC19C = (val == true ) ? false: true;}
        },       
        contactWithC19DiagnosedPersonYes:
        {
          get: function() {return this.input.contactWithC19DiagnosedPerson},
          set: function(val) { this.input.contactWithC19DiagnosedPerson = val;}
        },   
        contactWithC19DiagnosedPersonNo:
        { 
          get: function() {return ( this.input.contactWithC19DiagnosedPerson == true ) ? false : true;},
          set: function(val)
          { 
            this.input.contactWithC19DiagnosedPerson = (val == true ) ? false: true;
            this.input.contactWithC19DiagnosedPersonExplain = "";
          }
        },
        contactWithC19TravelerYes:
        {
          get: function() {return this.input.contactWithC19Traveler},
          set: function(val) { this.input.contactWithC19Traveler = val;}
        },   
        contactWithC19TravelerNo:
        { 
          get: function() {return ( this.input.contactWithC19Traveler == true ) ? false : true;},
          set: function(val)
          { 
            this.input.contactWithC19Traveler = (val == true ) ? false: true;
            this.input.contactWithC19TravelerCountryId = 0;
            this.input.contactWithC19TravelerExplain = "";
          }
        },
        chronicConditionsYes:
        {
          get: function() {return this.input.chronicConditions},
          set: function(val) { this.input.chronicConditions = val;}
        },
        chronicConditionsNo:
        { 
          get: function() {return ( this.input.chronicConditions == true ) ? false : true;},
          set: function(val)
                { 
                  this.input.chronicConditions = (val == true ) ? false: true;
                  this.input.chronicConditionsExplain = "";
                }
        },
        compromisedImmunityYes:
        {
          get: function() {return this.input.compromisedImmunity},
          set: function(val) { this.input.compromisedImmunity = val;}
        },
        compromisedImmunityNo:
        { 
          get: function() {return ( this.input.compromisedImmunity == true ) ? false : true;},
          set: function(val)
                { 
                  this.input.compromisedImmunity = (val == true ) ? false: true;
                  this.input.compromisedImmunityExplain = "";
                }
        },
        vaccinationYes:
        {
          get: function() {return this.input.vaccination},
          set: function(val) 
          { 
            this.input.vaccination = val;
            this.input.vaccineId = 0;
          }
        },
        vaccinationNo:
        { 
          get: function() {return ( this.input.vaccination == true ) ? false : true;},
          set: function(val)
          { 
            this.input.vaccination = (val == true ) ? false: true;
            this.input.vaccineId = 0;
            this.input.vaccineDose1 = "";
            this.input.vaccineDose2 = "";
            this.input.vaccineDose3 = "";
          }
        },
        vaccineDose1:
        {
          get() {
            if(new Date(this.input.vaccineDose1).getTime() == new Date("1900-01-01T00:00:00").getTime())
            { 
              return "";
            }
            return moment(this.input.vaccineDose1).format('YYYY-MM-DD');
          },
          set(val)
          {
            this.input.vaccineDose1 = val;
          }
        }, 
        vaccineDose2:
        {
          get() {
            if(new Date(this.input.vaccineDose2).getTime() == new Date("1900-01-01T00:00:00").getTime())
            { 
              return "";
            }
            return moment(this.input.vaccineDose2).format('YYYY-MM-DD');
          },
          set(val)
          {
            this.input.vaccineDose2 = val;
          }
        }, 
        vaccineDose3:
        {
          get() {
            if(new Date(this.input.vaccineDose3).getTime() == new Date("1900-01-01T00:00:00").getTime())
            { 
              return "";
            }
            return moment(this.input.vaccineDose3).format('YYYY-MM-DD');
          },
          set(val)
          {
            this.input.vaccineDose3 = val;
          }
        }, 
        // SECTION 2
        temperaturePastNDaysYes:
        {
          get: function() {return this.input.temperaturePastNDays},
          set: function(val) { this.input.temperaturePastNDays = val;}
        },
        temperaturePastNDaysNo:
        { 
          get: function() {return ( this.input.temperaturePastNDays == true ) ? false : true;},
          set: function(val){ this.input.temperaturePastNDays = (val == true ) ? false: true;}
        },
        usedDigitalThermometerYes:
        {
          get: function() {return this.input.usedDigitalThermometer},
          set: function(val) { this.input.usedDigitalThermometer = val;}
        },
        usedDigitalThermometerNo:
        { 
          get: function() {return ( this.input.usedDigitalThermometer == true ) ? false : true;},
          set: function(val){ this.input.usedDigitalThermometer = (val == true ) ? false: true;}
        },
        // SECTION 3
        wetCoughProductiveYes:
        {
          get: function() {return this.input.wetCoughProductive},
          set: function(val) { this.input.wetCoughProductive = val;}
        },
        wetCoughProductiveNo:
        {
          get: function() {return ( this.input.wetCoughProductive == true ) ? false : true;},
          set: function(val){ this.input.wetCoughProductive = (val == true ) ? false: true;}
        },
        wetCoughNonProductiveYes:
        {
          get: function() {return this.input.wetCoughNonProductive},
          set: function(val) { this.input.wetCoughNonProductive = val;}
        },
        wetCoughNonProductiveNo:
        {
          get: function() {return ( this.input.wetCoughNonProductive == true ) ? false : true;},
          set: function(val){ this.input.wetCoughNonProductive = (val == true ) ? false: true;}
        },
        dryCoughYes:
        {
          get: function() {return this.input.dryCough},
          set: function(val) { this.input.dryCough = val;}
        },
        dryCoughNo:
        {
          get: function() {return ( this.input.dryCough == true ) ? false : true;},
          set: function(val){ this.input.dryCough = (val == true ) ? false: true;}
        },        
        soreThroatYes:
        {
          get: function() {return this.input.soreThroat},
          set: function(val) { this.input.soreThroat = val;}
        },
        soreThroatNo:
        {
          get: function() {return ( this.input.soreThroat == true ) ? false : true;},
          set: function(val){ this.input.soreThroat = (val == true ) ? false: true;}
        },
        congestionRunningNoseYes:
        {
          get: function() {return this.input.congestionRunningNose},
          set: function(val) { this.input.congestionRunningNose = val;}
        },
        congestionRunningNoseNo:
        {
          get: function() {return ( this.input.congestionRunningNose == true ) ? false : true;},
          set: function(val){ this.input.congestionRunningNose = (val == true ) ? false: true;}
        },
        shortnessOfBreathYes:
        {
          get: function() {return this.input.shortnessOfBreath},
          set: function(val) { this.input.shortnessOfBreath = val;}
        },
        shortnessOfBreathNo:
        {
          get: function() {return ( this.input.shortnessOfBreath == true ) ? false : true;},
          set: function(val){ this.input.shortnessOfBreath = (val == true ) ? false: true;}
        },
        chillsYes:
        {
          get: function() {return this.input.chills},
          set: function(val) { this.input.chills = val;}
        },
        chillsNo:
        {
          get: function() {return ( this.input.chills == true ) ? false : true;},
          set: function(val){ this.input.chills = (val == true ) ? false: true;}
        },
        headacheYes:
        {
          get: function() {return this.input.headache},
          set: function(val) { this.input.headache = val;}
        },
        headacheNo:
        {
          get: function() {return ( this.input.headache == true ) ? false : true;},
          set: function(val){ this.input.headache = (val == true ) ? false: true;}
        },
        lossOfSmellYes:
        {
          get: function() {return this.input.lossOfSmell},
          set: function(val) { this.input.lossOfSmell = val;}
        },
        lossOfSmellNo:
        {
          get: function() {return ( this.input.lossOfSmell == true ) ? false : true;},
          set: function(val){ this.input.lossOfSmell = (val == true ) ? false: true;}
        },
        lossOfTasteYes:
        {
          get: function() {return this.input.lossOfTaste},
          set: function(val) { this.input.lossOfTaste = val;}
        },
        lossOfTasteNo:
        {
          get: function() {return ( this.input.lossOfTaste == true ) ? false : true;},
          set: function(val){ this.input.lossOfTaste = (val == true ) ? false: true;}
        },
        lossOfAppetiteYes:
        {
          get: function() {return this.input.lossOfAppetite},
          set: function(val) { this.input.lossOfAppetite = val;}
        },
        lossOfAppetiteNo:
        {
          get: function() {return ( this.input.lossOfAppetite == true ) ? false : true;},
          set: function(val){ this.input.lossOfAppetite = (val == true ) ? false: true;}
        },
        pinkEyeYes:
        {
          get: function() {return this.input.pinkEye},
          set: function(val) { this.input.pinkEye = val;}
        },
        pinkEyeNo:
        {
          get: function() {return ( this.input.pinkEye == true ) ? false : true;},
          set: function(val){ this.input.pinkEye = (val == true ) ? false: true;}
        },
        bodyAchesMuscleJointPainYes:
        {
          get: function() {return this.input.bodyAchesMuscleJointPain},
          set: function(val) { this.input.bodyAchesMuscleJointPain = val;}
        },
        bodyAchesMuscleJointPainNo:
        {
          get: function() {return ( this.input.bodyAchesMuscleJointPain == true ) ? false : true;},
          set: function(val){ this.input.bodyAchesMuscleJointPain = (val == true ) ? false: true;}
        },
        suddenConfusionYes:
        {
          get: function() {return this.input.suddenConfusion},
          set: function(val) { this.input.suddenConfusion = val;}
        },
        suddenConfusionNo:
        {
          get: function() {return ( this.input.suddenConfusion == true ) ? false : true;},
          set: function(val){ this.input.suddenConfusion = (val == true ) ? false: true;}
        },
        digestiveSystemYes:
        {
          get: function() {return this.input.digestiveSystem},
          set: function(val) { this.input.digestiveSystem = val;}
        },
        digestiveSystemNo:
        {
          get: function() {return ( this.input.digestiveSystem == true ) ? false : true;},
          set: function(val){ this.input.digestiveSystem = (val == true ) ? false: true;}
        },
        fatigueYes:
        {
          get: function() {return this.input.fatigue},
          set: function(val) { this.input.fatigue = val;}
        },
        fatigueNo:
        {
          get: function() {return ( this.input.fatigue == true ) ? false : true;},
          set: function(val){ this.input.fatigue = (val == true ) ? false: true;}
        },
        chestPainYes:
        {
          get: function() {return this.input.chestPain},
          set: function(val) { this.input.chestPain = val;}
        },
        chestPainNo:
        {
          get: function() {return ( this.input.chestPain == true ) ? false : true;},
          set: function(val){ this.input.chestPain = (val == true ) ? false: true;}
        },
        agreementYes:
        {
          get: function() {return this.input.agreement},
          set: function(val) { this.input.agreement = val;}
        },
        agreementNo:
        {
          get: function() {return ( this.input.agreement == true ) ? false : true;},
          set: function(val){ this.input.agreement = (val == true ) ? false: true;}
        },
        feelingTodayNotGreat:
        {
          get: function() {return this.input.MH1FeelingToday},
          set: function(val) { this.input.MH1FeelingToday = val;}
        },
        feelingTodayFine:
        {
          get: function() {return ( this.input.MH1FeelingToday == true ) ? false : true;},
          set: function(val){ 
            this.input.MH1FeelingToday = (val == true ) ? false: true;
            this.input.MH1FeelingTodayWeeks = false;
            this.input.MH1FeelingTodayWeeksNervousAnxious = 0;
            this.input.MH1FeelingTodayWeeksWorrying = 0;
            this.input.MH1FeelingTodayWeeksDepression = 0;
            this.input.MH1FeelingTodaySuicidalHomicidal = 0;
            this.input.MH2WakeRestful = true;
            this.input.MH2WakeRestfulHoursOfSleep = 0;
            this.input.MH2WakeRestfulSleepTimeliness = true;
            this.input.MH3FollowingDoctorOrders = true;
            this.input.MH4TakingPrescribedMeds = true;
            this.input.MH5Accommodations = false;
            this.input.MH5AccommodationsJobApplicationAdjustment = false;
            this.input.MH5AccommodationsWorkScheduleModification = false;
            this.input.MH5AccommodationsEqualBenefitsChange = false;
            this.input.MH5AccommodationsDoctorsAppointment = false;
            this.input.MH6Other = false;
            this.input.MH6OtherExplain = "";
          }
        },
        MH2WakeRestfulSleepTimelinessYes:
        {
          get: function() {return this.input.MH2WakeRestfulSleepTimeliness},
          set: function(val) { this.input.MH2WakeRestfulSleepTimeliness = val;}
        },
        MH2WakeRestfulSleepTimelinessNo:
        {
          get: function() {return ( this.input.MH2WakeRestfulSleepTimeliness == true ) ? false : true;},
          set: function(val){ this.input.MH2WakeRestfulSleepTimeliness = (val == true ) ? false: true;}
        },
        MH1FeelingTodayWeeksYes:
        {
          get: function() {return this.input.MH1FeelingTodayWeeks},
          set: function(val) { this.input.MH1FeelingTodayWeeks = val;}
        },
        MH1FeelingTodayWeeksNo:
        {
          get: function() {return ( this.input.MH1FeelingTodayWeeks == true ) ? false : true;},
          set: function(val){ this.input.MH1FeelingTodayWeeks = (val == true ) ? false: true;
            this.input.MH1FeelingTodayWeeksNervousAnxious = 0;
            this.input.MH1FeelingTodayWeeksWorrying = 0;
            this.input.MH1FeelingTodayWeeksDepression = 0;
            this.input.MH1FeelingTodaySuicidalHomicidal = 0;
          }
        },
        MH2WakeRestfulYes:
        {
          get: function() {return this.input.MH2WakeRestful},
          set: function(val) { this.input.MH2WakeRestful = val;}
        },
        MH2WakeRestfulNo:
        {
          get: function() {return ( this.input.MH2WakeRestful == true ) ? false : true;},
          set: function(val){ this.input.MH2WakeRestful = (val == true ) ? false: true;
            this.input.MH2WakeRestfulHoursOfSleep = 0;
            this.input.MH2WakeRestfulSleepTimeliness = true;
          }
        },
        MH3FollowingDoctorOrdersYes:
        {
          get: function() {return this.input.MH3FollowingDoctorOrders},
          set: function(val) { this.input.MH3FollowingDoctorOrders = val;}
        },
        MH3FollowingDoctorOrdersNo:
        {
          get: function() {return ( this.input.MH3FollowingDoctorOrders == true ) ? false : true;},
          set: function(val){ this.input.MH3FollowingDoctorOrders = (val == true ) ? false: true;}
        },
        MH4TakingPrescribedMedsYes:
        {
          get: function() {return this.input.MH4TakingPrescribedMeds},
          set: function(val) { this.input.MH4TakingPrescribedMeds = val;}
        },
        MH4TakingPrescribedMedsNo:
        {
          get: function() {return ( this.input.MH4TakingPrescribedMeds == true ) ? false : true;},
          set: function(val){ this.input.MH4TakingPrescribedMeds = (val == true ) ? false: true;}
        },        
        MH5AccommodationsYes:
        {
          get: function() {return this.input.MH5Accommodations},
          set: function(val) { this.input.MH5Accommodations = val;}
        },
        MH5AccommodationsNo:
        {
          get: function() {return ( this.input.MH5Accommodations == true ) ? false : true;},
          set: function(val){ this.input.MH5Accommodations = (val == true ) ? false: true;
            this.input.MH5AccommodationsJobApplicationAdjustment = false;
            this.input.MH5AccommodationsWorkScheduleModification = false;
            this.input.MH5AccommodationsEqualBenefitsChange = false;
            this.input.MH5AccommodationsDoctorsAppointment = false;
          }
        },
        MH5AccommodationsJobApplicationAdjustmentYes:
        {
          get: function() {return this.input.MH5AccommodationsJobApplicationAdjustment},
          set: function(val) { this.input.MH5AccommodationsJobApplicationAdjustment = val;}
        },
        MH5AccommodationsJobApplicationAdjustmentNo:
        {
          get: function() {return ( this.input.MH5AccommodationsJobApplicationAdjustment == true ) ? false : true;},
          set: function(val){ this.input.MH5AccommodationsJobApplicationAdjustment = (val == true ) ? false: true;}
        },
        MH5AccommodationsWorkScheduleModificationYes:
        {
          get: function() {return this.input.MH5AccommodationsWorkScheduleModification},
          set: function(val) { this.input.MH5AccommodationsWorkScheduleModification = val;}
        },
        MH5AccommodationsWorkScheduleModificationNo:
        {
          get: function() {return ( this.input.MH5AccommodationsWorkScheduleModification == true ) ? false : true;},
          set: function(val){ this.input.MH5AccommodationsWorkScheduleModification = (val == true ) ? false: true;}
        },
        MH5AccommodationsEqualBenefitsChangeYes:
        {
          get: function() {return this.input.MH5AccommodationsEqualBenefitsChange},
          set: function(val) { this.input.MH5AccommodationsEqualBenefitsChange = val;}
        },
        MH5AccommodationsEqualBenefitsChangeNo:
        {
          get: function() {return ( this.input.MH5AccommodationsEqualBenefitsChange == true ) ? false : true;},
          set: function(val){ this.input.MH5AccommodationsEqualBenefitsChange = (val == true ) ? false: true;}
        },
        MH5AccommodationsDoctorsAppointmentYes:
        {
          get: function() {return this.input.MH5AccommodationsDoctorsAppointment},
          set: function(val) { this.input.MH5AccommodationsDoctorsAppointment = val;}
        },
        MH5AccommodationsDoctorsAppointmentNo:
        {
          get: function() {return ( this.input.MH5AccommodationsDoctorsAppointment == true ) ? false : true;},
          set: function(val){ this.input.MH5AccommodationsDoctorsAppointment = (val == true ) ? false: true;}
        },
        MH6OtherYes:
        {
          get: function() {return this.input.MH6Other},
          set: function(val) { this.input.MH6Other = val;}
        },
        MH6OtherNo:
        {
          get: function() {return ( this.input.MH6Other == true ) ? false : true;},
          set: function(val){ 
            this.input.MH6Other = (val == true ) ? false: true;
            this.input.MH6OtherExplain = "";}
        },
      },
      data() {
        
      return {
        input: {
            isLoading: false,
            c19RiskAssessmentProfileId:-1,
            currentlyHaveC19: false,
            previousTestedPositiveC19:false,
            previousTestedPositiveC19A:false,
            previousTestedPositiveC19B:false,
            previousTestedPositiveC19C:false,
            contactWithC19DiagnosedPerson:false,
            contactWithC19DiagnosedPersonExplain:"",
            contactWithC19Traveler:false,
            contactWithC19TravelerCountryId:0,
            contactWithC19TravelerExplain:"",
            chronicConditions:false,
            chronicConditionsExplain:"",
            compromisedImmunity:false,
            compromisedImmunityExplain:"",
            vaccination:false,
            vaccineId:0,
            vaccineDose1:"1/1/1900",
            vaccineDose2:"1/1/1900",
            vaccineDose3:"1/1/1900",
            temperature:"",
            temperaturePastNDays:false,
            usedDigitalThermometer:false,
            wetCoughProductive:false,
            wetCoughNonProductive:false,
            dryCough:false,
            soreThroat:false,
            congestionRunningNose:false,
            shortnessOfBreath:false,
            chills:false,
            headache:false,
            lossOfSmell:false,
            lossOfTaste:false,
            lossOfAppetite:false,
            pinkEye:false,
            bodyAchesMuscleJointPain:false,
            suddenConfusion:false,
            digestiveSystem:false,
            fatigue:false,
            chestPain:false,
            symptomStartDate:"",
            agreement:false,
            MH1FeelingToday:false,
            MH1FeelingTodayWeeks:false,
            MH1FeelingTodayWeeksNervousAnxious:0,
            MH1FeelingTodayWeeksWorrying:0,
            MH1FeelingTodayWeeksDepression:0,
            MH1FeelingTodaySuicidalHomicidal:0,
            MH2WakeRestful:true,
            MH2WakeRestfulHoursOfSleep:0,
            MH2WakeRestfulSleepTimeliness:true,
            MH3FollowingDoctorOrders:true,
            MH4TakingPrescribedMeds:true,
            MH5Accommodations:false,
            MH5AccommodationsJobApplicationAdjustment:false,
            MH5AccommodationsWorkScheduleModification:false,
            MH5AccommodationsEqualBenefitsChange:false,
            MH5AccommodationsDoctorsAppointment:false,
            MH6Other:false,
            MH6OtherExplain:""
        },
        pageYOffset:0,
      }
  },
  methods:
  {
    load()
    {
      try
      {
        if(window.sessionKey != '')
        {
          // CHANGE THE MENU FROM LOGON
          
          SUPPORT.showServiceMenus();
          
          document.getElementById('menuLogoff').classList.remove('is-hidden');
          document.getElementById('menuMember').innerHTML = '<span v-on:click="toggleMenus" style="white-space:pre">Hi ' + window.firstName + '</span>'
          document.getElementById('menuCOVID19Questionnaire').classList.add('is-hidden');
        }                   

        API.readRiskAssessmentQuestionnaire(window.sessionKey, this.$i18n.locale)
        .then(response => {
          if(response.data.hasError == true)
          {
            this.input.isLoading = false;
            this.$generalMessage(messageBox, response.data.errorMessage);
            SUPPORT.securityCheck(response.data.errorId);
          }
          else
          { 
            if(response.data.inviteRequired)
            {              
              // REDIRECT TO MANAGE INVITES
               let menuCOVID19Questionnaire = document.getElementById('menuCOVID19Questionnaire');
              menuCOVID19Questionnaire.classList.remove('is-hidden');
              this.$router.push( { path: "/members/invite"} );
              return;
            }

            this.input.currentlyHaveC19 = response.data.currentlyHaveC19;
            this.input.previousTestedPositiveC19 = response.data.previousTestedPositiveC19;
            this.input.previousTestedPositiveC19A = response.data.previousTestedPositiveC19A;
            this.input.previousTestedPositiveC19B = response.data.previousTestedPositiveC19B;
            this.input.previousTestedPositiveC19C = response.data.previousTestedPositiveC19C;
            this.input.contactWithC19DiagnosedPerson = response.data.contactWithC19DiagnosedPerson;
            this.input.contactWithC19DiagnosedPersonExplain = response.data.contactWithC19DiagnosedPersonExplain;
            this.input.contactWithC19Traveler = response.data.contactWithC19Traveler;
            this.input.contactWithC19TravelerCountryId = response.data.contactWithC19TravelerCountryId;
            this.input.contactWithC19TravelerExplain = response.data.contactWithC19TravelerExplain;
            this.input.chronicConditions = response.data.chronicConditions;
            this.input.chronicConditionsExplain = response.data.chronicConditionsExplain;
            this.input.compromisedImmunity = response.data.compromisedImmunity;
            this.input.compromisedImmunityExplain = response.data.compromisedImmunityExplain;
            this.input.vaccination = response.data.vaccination;
            this.input.vaccineId = response.data.vaccineId;
            this.input.vaccineDose1 = response.data.vaccineDose1; //moment(response.data.vaccineDose1).format('MM-DD-YYYY');
            this.input.vaccineDose2 = response.data.vaccineDose2; //moment(response.data.vaccineDose2).format('MM-DD-YYYY');
            this.input.vaccineDose3 = response.data.vaccineDose3; 

          }
        }).catch( e =>
        {
          this.$generalMessage( messageBox, e );            
        })
      }
      catch(e)
      {
        this.$generalMessage( messageBox, e );
      }
    },
    submit()
    {
      this.input.isLoading = true;
      this.pageYOffset = window.pageYOffset;

      // VALIDATE INPUT RULES
      
      if(!this.validate())
      {
        this.input.isLoading = false;
        window.scrollTo(0, window.pageYOffset);
        return;
      }

      var message = this.buildPositiveList();
    
      /* NEW CONFIRMATION METHOD */
      if(SUPPORT.isSupported())
      {
        var clientWidth = document.documentElement.clientWidth;
        var theWidth = (clientWidth > 1023) ? 600 : 300;
        //var theHeight = (clientWidth < 600) ? 250 : 200;
        var theHeight = (clientWidth < 600) ? 385 : 350;

        // DISPLAY THE STD MESSAGE INFORMATION BOX
        this.$modal.show(confirmBox, {
          text: message,
          func: this.confirmCallBack,
        }, 
        {
          draggable: true,
          width: theWidth, 
          height: theHeight,
          clickToClose: false,
          styles: {"border-radius":"15px"}
        });
      }
      else{
        
        var title = this.$t("c19confirm.statement") //"eHealth Engagement, LLC.\n\nYou answered Yes to the following questions. Please review and confirm your entries.\n\n";
        var msg = ''
        var i = 0;
        for(i = 0; i < message.length ; i++) 
        {
          msg = msg + message[i] + '\n';
        }
        
        var r = confirm(title + msg);
        if(r == true)
        {
          this.confirmCallBack(1);
        }
        else
        {
          this.input.isLoading = false;
          this.confirmCallBack(0);
        }
      }
     
    },
    confirmCallBack(result)
    {
      
      if(result == 1) // YES RETURN RESULT
      {
        this.submit2();
      }
      else
      {
        
        if(this.input.symptomStartDate == "1900-01-01")
        {
          
          this.input.symptomStartDate = "";
        }
        
        this.input.isLoading = false;
        window.scrollTo(0, this.pageYOffset);
      }
    },
    buildPositiveList()
    {
      var list = Array();

      // SECTION 1
      if(this.input.currentlyHaveC19 == true)
      {
        list.push(this.$t("c19.s1Q1"));
        //list.push('1. Are you currently diagnosed as positive (with antibody or nasal swab test) for COVID-19?');
      }
      if(this.input.previousTestedPositiveC19 == true)
      {
         list.push(this.$t("c19.s1Q2"));
        //list.push('2. Have you previously tested positive (with antibody or nasal swab test) for COVID-19?');
      }
      if(this.input.previousTestedPositiveC19A == true)
      {
        list.push(this.$t("c19.s1Q2a"));
        //list.push('A.	At least 10 days have passed from the onset of symptoms and no subsequent illness.');
      }
      if(this.input.previousTestedPositiveC19B == true)
      {
        list.push(this.$t("c19.s1Q2b"));
        //list.push('B.	There have been 3 days without fever and without the use of fever reducing medications.');
      }
      if(this.input.previousTestedPositiveC19C == true)
      {
        list.push(this.$t("c19.s1Q2c"));
        //list.push('C.	Respiratory symptoms: cough and/or shortness of breath have resolved.');
      }
      if(this.input.contactWithC19DiagnosedPerson == true)
      {
        list.push(this.$t("c19.s1Q3"));
        //list.push('3.	Have you had close or direct contact with a person diagnosed with COVID-19 in the past 14 days?');
      }
      if(this.input.contactWithC19Traveler == true)
      {
        list.push(this.$t("c19.s1Q4"));
        //list.push('4.	Have you had close or direct contact with someone who has travelled to another country in the past 14 days?');
      }
      if(this.input.chronicConditions == true)
      {
        list.push(this.$t("c19.s1Q5"));
        //list.push('5.	Do you have any chronic medical conditions?');
      }
      if(this.input.compromisedImmunity == true)
      {
        list.push(this.$t("c19.s1Q6"));
        //list.push('6.	Do you have any compromised immunity issues?');
      }
      
      // SECTION 2
      //list.push(' Please enter your temperature reading for today = ' + this.input.temperature);
      list.push(this.$t("c19.s2Temperature") + " = " + this.input.temperature);
      if(this.input.temperaturePastNDays == true)
      {
        
        list.push(this.$t("c19.s2Q1"));
        //list.push('1. Have you had a temperature within the past 3 days?');
      }
      if(this.input.usedDigitalThermometer == true)
      {
        list.push(this.$t("c19.s2Q2"));
        //list.push('2. Did you use a digital thermometer?');
      }
      // SECTION 3
      if(this.input.wetCoughProductive == true)
      {
        list.push(this.$t("c19.s3Q1"));
        //list.push('1. Wet cough - Productive (A cough that produces mucus or phlegm.)');
      }
      if(this.input.wetCoughNonProductive == true)
      {
        list.push(this.$t("c19.s3Q2"));
        //list.push('	2. Wet cough - Non-productive (Does not bring up any mucus or phlegm.)');
      }
      if(this.input.dryCough == true)
      {
        list.push(this.$t("c19.s3Q3"));
        //list.push('3. Dry cough - (Does not bring up any mucus or phlegm.)');
      }
      if(this.input.soreThroat == true)
      {
        list.push(this.$t("c19.s3Q4"));
        //list.push('4. Sore throat');
      }
      if(this.input.congestionRunningNose == true)
      {
        list.push(this.$t("c19.s3Q5"));
        //list.push('5. Congestion and/or running nose (Not related to seasonal allergies.)');
      }
      if(this.input.shortnessOfBreath == true)
      {
        list.push(this.$t("c19.s3Q6"));
        //list.push('6. Shortness of breath');
      }
      if(this.input.chills == true)
      {
        list.push(this.$t("c19.s3Q7"));
        //list.push('7. Chills');
      }
      if(this.input.headache == true)
      {
        list.push(this.$t("c19.s3Q8"));
        //list.push('8. Headache');
      }
      if(this.input.lossOfSmell == true)
      {
        list.push(this.$t("c19.s3Q9"));
        //list.push('9. Loss of smell');
      }
      if(this.input.lossOfTaste == true)
      {
        list.push(this.$t("c19.s3Q10"));
        //list.push('10. Loss of taste');
      }
      if(this.input.lossOfAppetite == true)
      {
        list.push(this.$t("c19.s3Q11"));
        //list.push('11. Loss of appetite');
      }
      if(this.input.pinkEye == true)
      {
        list.push(this.$t("c19.s3Q12"));
        //list.push('12. Red eyes (Not related to seasonal allergies.)');
      }
      if(this.input.bodyAchesMuscleJointPain == true)
      {
        list.push(this.$t("c19.s3Q13"));
        //list.push('13. Body aches muscle and/or joint pain');
      }
      if(this.input.suddenConfusion == true)
      {
        list.push(this.$t("c19.s3Q14"));
        //list.push('14. Sudden confusion');
      }
      if(this.input.digestiveSystem == true)
      {
        list.push(this.$t("c19.s3Q15"));
        //list.push('15. Digestive symptoms including diarrhea');
      }
      if(this.input.fatigue == true)
      {
        list.push(this.$t("c19.s3Q16"));
        //list.push('16. Fatigue (Unusual or excessive whole-body tiredness not relieved by sleep.)');
      }
      if(this.input.chestPain == true)
      {
        list.push(this.$t("c19.s3Q17"));
        //list.push('17. Chest pain');
      }
      
      // SECTION 5
      if(this.input.MH1FeelingTodayWeeks == true)
      {
        list.push(this.$t("1. Anxienty / Depression"));
        //list.push('1. Anxienty / Depression');
      }
      if(this.input.MH1FeelingTodayWeeksNervousAnxious > 0)
      {
        list.push(this.$t("1.a Nervous / Anxious"));
        //list.push('1.a Nervous / Anxious');
      }
      if(this.input.MH1FeelingTodayWeeksWorrying > 0)
      {
        list.push(this.$t("1.b Worrying"));
        //list.push('1.b Worrying');
      }
      if(this.input.MH1FeelingTodayWeeksDepression > 0)
      {
        list.push(this.$t("1.c Depression"));
        //list.push('1.c Depression');
      }
      if(this.input.MH1FeelingTodaySuicidalHomicidal > 0)
      {
        list.push(this.$t("1.d Suicidal or Homicidal."));
        //list.push('1.d Suicidal or Homicidal.');
      }
      if(this.input.MH2WakeRestful == false)
      {
        list.push(this.$t("2. Wake up restful."));
        //list.push('Wake up restful.');
      }
      if(this.input.MH2WakeRestfulHoursOfSleep > 0)
      {
        list.push(this.$t("2.a How many hours."));
        //list.push('How many hours.');
      }
      if(this.input.MH2WakeRestfulSleepTimeliness == false)
      {
        list.push(this.$t("2.b Go to sleep time."));
        //list.push('Go to sleep time.');
      }
      if(this.input.MH3FollowingDoctorOrders == false)
      {
        list.push(this.$t("3. Following doctors recommendations."));
        //list.push('Following doctors recommendations.');
      }
      if(this.input.MH4TakingPrescribedMeds == false)
      {
        list.push(this.$t("T4. aking prescribed medications."));
        //list.push('Taking prescribed medications.');
      }
      if(this.input.MH5Accommodations == true)
      {
        list.push(this.$t("5. Requesting Accommodation."));
        //list.push('Taking prescribed medications.');
      }
      if(this.input.MH5AccommodationsJobApplicationAdjustment == true)
      {
        list.push(this.$t("5.a Adjustments to job application."));
        //list.push('.a adjustments to job application');
      }
      if(this.input.MH5AccommodationsWorkScheduleModification == true)
      {
        list.push(this.$t("5.b Modify work environment."));
        //list.push('5.b Modify work environment.');
      }
      if(this.input.MH5AccommodationsEqualBenefitsChange == true)
      {
        list.push(this.$t("5.c Change employee disability."));
        //list.push('5.b Change employee disability.');
      }
      if(this.input.MH5AccommodationsDoctorsAppointment == true)
      {
        list.push(this.$t("5.d Request doctors appointment."));
        //list.push('5.d Request doctors appointment.');
      }
      if(this.input.MH6Other == true)
      {
        list.push(this.$t("6. Other issue."));
        //list.push('6. Other issue.');
      }
      
      return list;
    },
    submit2()
    {
      try
      {

         
       /* this.isLoading = true;

        // VALIDATE INPUT RULES
        if(!this.validate())
        {
          this.isLoading = false;
          return;
        } */
       
        API.createC19RiskAssessment(
          window.sessionKey,
          this.input.c19RiskAssessmentProfileId,
          this.input.currentlyHaveC19,
          this.input.previousTestedPositiveC19,
          this.input.previousTestedPositiveC19A,
          this.input.previousTestedPositiveC19B,
          this.input.previousTestedPositiveC19C,
          this.input.contactWithC19DiagnosedPerson,
          this.input.contactWithC19DiagnosedPersonExplain,
          this.input.contactWithC19Traveler,
          Number(this.input.contactWithC19TravelerCountryId),
          this.input.contactWithC19TravelerExplain,
          this.input.chronicConditions,
          this.input.chronicConditionsExplain,
          this.input.compromisedImmunity,
          this.input.compromisedImmunityExplain,
          this.input.vaccination,
          Number(this.input.vaccineId),
          ((this.input.vaccineDose1) == '' ? '1900-01-01T00:00:00.000' : this.input.vaccineDose1),
          ((this.input.vaccineDose2) == '' ? '1900-01-01T00:00:00.000' : this.input.vaccineDose2),
          ((this.input.vaccineDose3) == '' ? '1900-01-01T00:00:00.000' : this.input.vaccineDose3),
          Number(this.input.temperature),
          this.input.temperaturePastNDays,
          this.input.usedDigitalThermometer,
          this.input.wetCoughProductive,
          this.input.wetCoughNonProductive,
          this.input.dryCough,
          this.input.soreThroat,
          this.input.congestionRunningNose,
          this.input.shortnessOfBreath,
          this.input.chills,
          this.input.headache,
          this.input.lossOfSmell,
          this.input.lossOfTaste,
          this.input.lossOfAppetite,
          this.input.pinkEye,
          this.input.bodyAchesMuscleJointPain,
          this.input.suddenConfusion,
          this.input.digestiveSystem,
          this.input.fatigue,
          this.input.chestPain,
          this.input.symptomStartDate + 'T00:00:00.000',
          this.input.MH1FeelingToday,
          this.input.MH1FeelingTodayWeeks,
          this.input.MH1FeelingTodayWeeksNervousAnxious,
          this.input.MH1FeelingTodayWeeksWorrying,
          this.input.MH1FeelingTodayWeeksDepression,
          this.input.MH1FeelingTodaySuicidalHomicidal,
          this.input.MH2WakeRestful,
          this.input.MH2WakeRestfulHoursOfSleep,
          this.input.MH2WakeRestfulSleepTimeliness,
          this.input.MH3FollowingDoctorOrders,
          this.input.MH4TakingPrescribedMeds,
          this.input.MH5Accommodations,
          this.input.MH5AccommodationsJobApplicationAdjustment,
          this.input.MH5AccommodationsWorkScheduleModification,
          this.input.MH5AccommodationsEqualBenefitsChange,
          this.input.MH5AccommodationsDoctorsAppointment,
          this.input.MH6Other,
          this.input.MH6OtherExplain
          )
          .then(response => {
            if(response.data.hasError == true)
            {
              
              //alert(response.data.errorMessage);
              this.$generalMessage(messageBox, response.data.errorMessage);
              if(response.data.errorId == "4000")
              {
                SUPPORT.clearSession();
                this.$router.push( { path: "/"} );
                this.input.isLoading = false;
                return;
              }
            }
            else
            {
              //alert("Your daily COVID-19 questionnaire has been successfully submitted.")
              this.$generalMessage(messageBox, this.$t("c19.hasBeenSubmitted")); /*"Your daily COVID-19 questionnaire has been successfully submitted.");*/
              
              // LOG THE SESSION OUT HERE
              API.logoff(window.sessionKey);
              window.sessionKey = '';

              // REDIRECT TO THE HOME PAGE
              this.$router.push( { path: "/"} );

            }
          }).catch( error =>
          {
            //alert( error );
            this.$generalMessage(messageBox, error );
            this.$router.push( { path: "/"} );
            
          })
          this.input.isLoading = false;
      }
      catch(e)
      {
        //alert(e);
        this.input.isLoading = false;
        this.$generalMessage(messageBox, e);
      }
    },
    validate()
    {
      var dateNow = new Date();
      var dDate1;
      var dDate2;
      var dDate3;
      var defaultDate;

      if(!this.input.agreement)
      {
        this.$generalMessage(messageBox, this.$t("c19.mustAgree")); /*"You must agree to the terms to continue.");*/
        return false;
      }

      // SECION 1
      if(this.input.contactWithC19DiagnosedPerson)
      {
        if(this.input.contactWithC19DiagnosedPersonExplain == "")
        {
          //alert("Please enter an explaination for question #3");
          this.$generalMessage(messageBox, this.$t("c19.enterExplanation") + /*"Please enter an explaination for question*/ " #3.");
          return false;
        }
      }
      if(this.input.contactWithC19Traveler)
      {
        if(this.input.contactWithC19TravelerCountryId <= 0 )
        {
          //alert("Please select a country for question #4");
          this.$generalMessage(messageBox, this.$t("c19.enterExplanationCountry") + /*"Please select a country for question*/ " #4.");
          return false;
        }
        if(this.input.contactWithC19TravelerExplain == "")
        {
          //alert("Please enter an explaination for question #4");
          this.$generalMessage(messageBox, this.$t("c19.enterExplanation") + /*"Please enter an explaination for question*/ " #4.");
          return false;
        }
      }
    
      if(this.input.chronicConditions)
      {
        if(this.input.chronicConditionsExplain == "")
        {
          //alert("Please enter an explaination for question #5");
          this.$generalMessage(messageBox, this.$t("c19.enterExplanation") + /* "Please enter an explaination for question*/ " #5.");
          return false;
        }
      }
    
      if(this.input.compromisedImmunity)
      {
        if(this.input.compromisedImmunityExplain == "")
        {
          //alert("Please enter an explaination for question #6");
          this.$generalMessage(messageBox, this.$t("c19.enterExplanation") + /* "Please enter an explaination for question*/ " #6.");
          return false;
        }
      }
      if(this.input.vaccination)
      {
        if( this.input.vaccineId <= 0 )
        {
          this.$generalMessage(messageBox, this.$t("c19.enterVaccine"));
          return false;
        }
        /* PFIZER/MODERNA */
        else if((this.input.vaccineId == 1) || (this.input.vaccineId == 2)) 
        {
          // MUST BE A PAST DATE
          dDate1 = new Date(this.input.vaccineDose1);
          dDate2 = new Date(this.input.vaccineDose2);
          dDate3 = new Date(this.input.vaccineDose3);
          defaultDate = new Date("1900-01-01T00:00:00").getTime();

          // CHECK FOR ALL BLANKS
          if((dDate1.getTime() == defaultDate) &&
                  (dDate2.getTime() == defaultDate) &&
                  (dDate3.getTime() == defaultDate) )
          {
            this.$generalMessage(messageBox, this.$t("c19.vaccineDoseEmpty")); 
            return false;
          }

          // CHECK FUTURE DATES
          if(dDate1 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("c19.vaccineDose1Future")); 
            return false;
          }
          else if(dDate2 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("c19.vaccineDose2Future")); 
            return false;
          }
          else if(dDate3 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("c19.vaccineDose3Future")); 
            return false;
          }
          
          // CHECK FOR PROPER DOSE DATE ORDER
          if(dDate2.getTime() != defaultDate)
          {
            // CHECKING DOSE 2
            if(dDate1 > dDate2)
            { 
              this.$generalMessage(messageBox, this.$t("c19.vaccineDose1GreaterThanDose2")); 
              return false;
            }
          }
          else if(dDate3.getTime() != defaultDate)
          {
            // CHECKING DOSE 3
            if(dDate2 > dDate3)
            { 
              this.$generalMessage(messageBox, this.$t("c19.vaccineDose2GreaterThanDose3")); 
              return false;
            }
          }
          
          // CHECK FOR VACCINATION PRIOR TO BOOSTER
          if((dDate1.getTime() == defaultDate) || 
            (dDate2.getTime() == defaultDate) ) 
          {
            if(dDate3.getTime() != defaultDate) 
            {
              this.$generalMessage(messageBox, this.$t("c19.vaccineDose1Or2Missing")); 
              return false;
            }
          }
        }
        // Johnson & Johnson
        else if(this.input.vaccineId == 3) 
        {
          dDate1 = new Date(this.input.vaccineDose1);
          dDate3 = new Date(this.input.vaccineDose3);
          defaultDate = new Date("1900-01-01T00:00:00").getTime();

          // CHECK FUTURE DATES
          if(dDate1 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("c19.vaccineDose1Future")); 
            return false;
          } 
          else if(dDate3 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("c19.vaccineDose3Future")); 
            return false;
          } 
          
          // CHECK DATE ORDER
          if(dDate3.getTime() != defaultDate)
          {
            if(dDate1 >= dDate3)
            { 
              this.$generalMessage(messageBox, this.$t("c19.vaccineDose1GreaterThanDose2")); 
              return false;
            }
          }
        }
      }
      
      // SECTION 2
      if(!parseFloat(this.input.temperature))
      {
        //alert("Please enter a valid temperature");
        this.$generalMessage(messageBox, this.$t("c19.validTemperature")); /*"Please enter a valid temperature.");*/
        return;
      }
      if(isNaN(this.input.temperature))
      {
        //alert("Please enter a valid temperature");
        this.$generalMessage(messageBox, this.$t("c19.validTemperature")); /*"Please enter an valid temperature.");*/
        return false;
      }
      if(parseFloat(this.input.temperature) <= 95.5)
      {
        this.$generalMessage(messageBox, this.$t("c19.temperatureBelow")); /*"Temperature cannot be below 95.5.");*/
        return false;
      }
      if(parseFloat(this.input.temperature) >= 116)
      {
        this.$generalMessage(messageBox, this.$t("c19.temperatureGreater")); /*"Temperature cannot be greater than 116.");*/
        return false;
      }

      // ROUND TO 2 DECIMAL PLACES
      this.input.temperature = +(Math.round(this.input.temperature + "e+2")  + "e-2")
      

      // SECTION 2
      if(this.input.wetCoughProductive ||
          this.input.wetCoughNonProductive ||
          this.input.dryCough ||
          this.input.soreThroat ||
          this.input.congestionRunningNose ||
          this.input.shortnessOfBreath ||
          this.input.chills ||
          this.input.headache ||
          this.input.lossOfSmell ||
          this.input.lossOfTaste ||
          this.input.lossOfAppetite ||
          this.input.pinkEye ||
          this.input.bodyAchesMuscleJointPain ||
          this.input.suddenConfusion ||
          this.input.digestiveSystem ||
          this.input.fatigue ||
          this.input.chestPain)
      {
        
        if(this.input.symptomStartDate == "")
        {
          //alert('You must enter a symptom start date to continue.');
          this.$generalMessage(messageBox, this.$t("c19.symptomStartDateMustEnter")); /*"You must enter a symptom start date to continue.");*/
          return false;
        }
        else
        {
          if(this.input.symptomStartDate.length != 10)
          {
            this.$generalMessage(messageBox, this.$t("c19.symptomStartDateLength")); /*"You must enter a symptom start date to continue.");*/
            return false;
          }
          
          var ssDate = new Date(this.input.symptomStartDate);
          
          // MUST BE A PAST DATE
          //var dateNow = new Date();
          if(ssDate > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("c19.symptomStartDateFuture")); /*"Symptom start date cannot be in the future."*/
            return false;
          }
          
          //this.input.symptomStartDate = this.input.symptomStartDate + 'T00:00:00.000';          
        }
      }
      else
      {
        this.input.symptomStartDate = "1900-01-01"; //"1900-01-01T00:00:00.000";
      }

      // SECTION 5 MENTAL HEALTH
      if(this.input.MH1FeelingToday == true) // NOT GREAT
      {
        if( ( this.input.MH1FeelingTodayWeeks == false ) && 
            ( this.input.MH2WakeRestful == true ) &&
            ( this.input.MH3FollowingDoctorOrders == true ) &&
            ( this.input.MH4TakingPrescribedMeds == true ) &&
            ( this.input.MH5Accommodations == false ) &&
            ( this.input.MH6Other == false ))
            {
              this.$generalMessage(messageBox, this.$t("Please select your issue under Medical Wellness.")); /*"Symptom start date cannot be in the future."*/
              return false;
            }
      }
      var str = this.$t("Please answer Medical Wellness question ");
      if(this.input.MH1FeelingTodayWeeks == true)
      {  
        if(this.input.MH1FeelingTodayWeeksNervousAnxious == 0)
        {
          this.$generalMessage(messageBox, str + "1.a");
          return false;
        }
        else if(this.input.MH1FeelingTodayWeeksWorrying == 0)
        {
          this.$generalMessage(messageBox, str + "1.b");
          return false;
        }
        else if(this.input.MH1FeelingTodayWeeksDepression == 0)
        {
          this.$generalMessage(messageBox, str + "1.c");
          return false;
        }
        else if(this.input.MH1FeelingTodaySuicidalHomicidal == 0)
        {
          this.$generalMessage(messageBox, str + "1.d");
          return false;
        }
      }
      
      if(this.input.MH2WakeRestful == false)
      {
        if(this.input.MH2WakeRestfulHoursOfSleep == 0)
        {
          this.$generalMessage(messageBox, str + "2.a");
          return false;
        }
      }
      if(this.input.MH5Accommodations == true)
      {
        if((this.input.MH5AccommodationsJobApplicationAdjustment == false) &&
          (this.input.MH5AccommodationsWorkScheduleModification == false) &&
          (this.input.MH5AccommodationsEqualBenefitsChange == false) &&
          (this.input.MH5AccommodationsDoctorsAppointment == false))
        {
          this.$generalMessage(messageBox, this.$t("Please select your Accommodation need under Medical Wellness."));
          return false;
        }
      }
      if(this.input.MH6Other == true)
      {
        if(this.input.MH6OtherExplain == "")
        {
          this.$generalMessage(messageBox, this.$t("Please explain your issue under Medical Wellness."));
          return false;
        }
      }

      return true;
    },
    /* isValidDate(d) 
    {
        return d instanceof Date && !isNaN(d);
    } */
  },
}
</script>


<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

// BEGIN SHARED STYLES
p {
  white-space: pre;
}
.disabled {
  background-color:darkgray;
}

.enabled {
  background-color: white;
}
// END SHARED STYLES

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  // NOT WORKING
  @-ms-viewport{
    width: device-width;
  }

  // BEGIN SIGNON DIALOG STYLES
  .main-table-screen
  {
    //height:1000px;
    max-width: 100%;
    width:100%;
    /*max-width:100%;
    min-width:100%;*/
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:15px;
    display:table;
  }
  #main-table-row1
  {
    //width:98%;
    height:15px; 
    //padding-left: 1%;
  }
  #main-table-row2-dialog-container-td
  {
    //max-width: 325px;
    margin:auto;
  }
  
  table { // KEY, FIXES TABLE TO MOBILE WIDTH
    table-layout:fixed;
  }
  /*table td {
    //word-wrap:break-word;
    word-break: break-word;
    white-space: normal;
  } */
  .dialog-table
  {
    width:96%;
 //   width:320px;
  }
 .border-dots
 {
    //border-bottom-style:none;
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:lightgray;//#4682B4 !important;
   /*  margin-top:10px;
    margin-bottom:5px; */
 }
 .border-dots-inner
 {
    border-bottom-style:none;
    
 }
 
 .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  }


  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 

  #dialog-td-title
  {
    width:100%;
    height:50px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle;
  }
  #dialog-td-instructions
  {
    width:100%;
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:10px;
    padding-right:10px;
    vertical-align: middle;
  }
  .dialog-signon-td-section-title
  {
    width:100%;
    height:35px;
    background-color:darkgray;//#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 12pt;
    font-style:italic;
    font-weight: bold;
    padding-left:5px;
    padding-right:5px;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
 
  .dialog-question
  {
    height:100%;
    width:100%;//300px;
    padding-left:5px;
    padding-right:5px;
    background-color:#343F68;
    color:white;
    word-wrap:break-word !important
  }
  .wrap
  {
    word-wrap:break-word !important;
    white-space: normal;
  }
  .dialog-question-space
  {
    width:0px;
    height:0px;
    background-color:#343F68;
    color:white;
  }
  .dialog-sub-question 
  {
    padding-left:5px;
    padding-right:5px;
    background-color:#343F68;
    color:white;
    vertical-align:top;
  }
  .dialog-sub-question-div
  {
    width:0px;
  }
  .dialog-input-field-right
  {
    width:100%;
    height:25px;
    vertical-align: top;
    background-color:#343F68;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  
  .dialog-input-field-explain
  {
    height:40px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-left:5px;
    padding-right:5px;
    //padding-bottom: 70px;
    //margin-bottom: 40px;
    width: 100%;//300px;
    resize:none;
    text-align: right;
  }
  .dialog-input-submit
  {
    height:50px;
    padding-top:10px;
    vertical-align:middle !important;
    background-color:darkgray;//#343F68;
    color:white;
    //padding-right:8px;
  }
  .col4-width
  {
    width:100% !important;
  }
  #main-table-row3
  {
    height:30px;
  }
  #country select
  {
    width:100px
  }
  #country select:focus
  {
    width:auto;
  }
  // END SIGNON DIALOG STYLES
}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  // BEGIN SIGNON DIALOG STYLES
 
  .main-table-screen
  {
    //height:1000px;
    width:100%;
    max-width:100%;
    min-width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    display:table;
    
  }
  #main-table-row1
  {
    height:50px; 
  }
  #main-table-row2-dialog-container-td
  {
    margin:auto;
  }
  
  .dialog-table
  {
    width:98%;
  }
 .border-dots
 {
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:#4682B4 !important;
 }
 .border-dots-inner
 {
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:#4682B4 !important;
 }
 
 .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }

  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 

  #dialog-td-title
  {
    width:20%;
    height:50px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle;
   
  }
  #dialog-td-instructions
  {
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:30px;
    padding-right:30px;
    vertical-align: middle;
  }
  .dialog-signon-td-section-title
  { 
    width:100%;
    height:35px;
    background-color:darkgray;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
 
  .dialog-question
  {
    height:25px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    word-wrap:break-word !important;
    //padding-right:8px;
  }
  .wrap
  {
    word-wrap:break-word !important;
  }
  .dialog-question-space
  {
    width:15px;
    background-color:#343F68;
    color:white;
  }
  
  .dialog-sub-question
  {
    background-color:#343F68;
    color:white;
    vertical-align:top;
  }
  .dialog-sub-question-div
  {
    width:25px;
  }

  .dialog-input-field-right
  {
    width:10%; //width="10%"
    height:25px;
    vertical-align: top;
    background-color:#343F68;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  
  .dialog-input-field-explain
  {
    height:40px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:25px;
    padding-top:5px;
    width:100%;
    resize:none;
    text-align: right;
  }
  .dialog-input-submit
  {
    height:50px;
    vertical-align: middle;
    background-color:darkgray;//#343F68;
    color:white;
    //padding-right:8px;
  }
  .col4-width
  {
    width:75% !important;
  }
  #main-table-row3
  {
    height:30px;
  }
  #country select
  {
    width:100px
  }
  #country select:focus
  {
    width:auto;
  }
  
  // END SIGNON DIALOG STYLES

}
</style>